import { render, staticRenderFns } from "./GeneralReportTable.vue?vue&type=template&id=2f01cea0&scoped=true&"
import script from "./GeneralReportTable.vue?vue&type=script&lang=js&"
export * from "./GeneralReportTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralReportTable.vue?vue&type=style&index=0&id=2f01cea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01cea0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow,VSimpleTable,VTooltip})
